<template>
	<el-container class="advanced-message">
		<el-main>
			<el-form ref="form" :model="form" :rules="rules" label-width="80px">
				<el-form-item label="间隔时间" prop="gapTime">
					<el-select v-model="form.timeUnit" style="width: 100px;margin-right: 5px;" size="mini">
					    <el-option label="秒" value="s"></el-option>
					    <el-option label="分" value="m"></el-option>
						<el-option label="时" value="h"></el-option>
					</el-select>
					<el-input-number v-model="form.gapTime"  :min="1" size="mini"></el-input-number>
				</el-form-item>
				<el-form-item v-for="(item, index) in form.rulesResponseList" label="回复内容" :key="'rulesResponseList.' + index"
					:prop="'rulesResponseList.' + index + '.response'" :rules="{
				      required: true, message: '请输入回复内容', trigger: 'blur'
				    }">
					<el-select v-model="item.responseType" placeholder="请选择" style="width: 100px;display: block;">
						<el-option label="文本" value="text"></el-option>
					</el-select>
					<el-input placeholder="请输入回复内容" type="textarea" v-model="item.response" style="width:80%;margin-top: 5px;" maxlength="300" show-word-limit></el-input>
					<!-- <div style="display: inline-block;margin-left: 5px;">
						<el-button type="text" @click.prevent="onAdd(item,index,'keyword')" v-show="index == form.rulesResponseList.length - 1">添加</el-button>
						<el-button type="text" @click.prevent="onRemove(item,index,'keyword')" v-show="form.rulesResponseList.length > 1">删除</el-button>
					</div> -->
				</el-form-item>
			</el-form>
			<div class="footer">
				<el-button @click="onDelete" size="mini" :disabled="!form.id">删 除</el-button>
				<el-button type="primary" size="mini" @click="onSubmit" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
				</el-button>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		props:{
			source:{
				default:''
			}
		},
		watch:{
			'source':{
				handler(value){
					if(value){
						this.$nextTick(() => {
							this.$refs.form.resetFields();
							this.getInfos();
						})
					}
				},
				immediate:true,
				deep:true
			}
		},
		data(){
			return {
				loading:false,
				form:{
					id:'',
					gapTime:'',
					timeUnit:'s',
					gapTime:1,
					rulesResponseList:[{
						orderno:0,
						response:'',
						responseType:'text'
					}]
				},
				rules:{
					gapTime: [{
						required: true,
						message: '请输入时间间隔',
						trigger: 'change'
					}]
				}
			}
		},
		methods:{
			onDelete(){
				this.$api.deleteWeiboMessageForSystem({id:this.form.id}).then(res => {
					this.$notify.success('删除成功');
					this.$refs.form.resetFields();
					this.form.id = '';
				})
			},
			onSubmit(){
				this.$refs['form'].validate((valid) => {
					 if(valid){
						this.loading = true;
						let params = {
								appid:this.source.weiboId,
								rulesKeyList:[{
									keysValue: this.form.gapTime + this.form.timeUnit,
									matchType: "3",
									orderno: 0,
									timeUnit: this.form.timeUnit,
									timeValue: this.form.gapTime
								}],
								rulesResponseList:this.form.rulesResponseList
						}
						if(this.form.id){
							params.id = this.form.id;
							this.$api.updateWeiboMessageForSystem(params).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('编辑成功');
							})
						}else {
							this.$api.addWeiboMessageForSystem(params).then(res => {
								this.loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('新增成功');
								this.getInfos();
							})
						}
					 }
				})
			},
			getInfos(){
				this.$api.getWeiboMessageListForSystem({
					data: {
					   appid: this.source.weiboId,
					},
					pageNum:1,
					pageSize: 10,
				}).then(res => {
					if(res.errcode != 0 || res.list.length == 0) return;
					this.form.rulesResponseList = res.list[0].rulesResponseList;
					this.form.id = res.list[0].id;
					const timeOriginal = res.list[0].rulesKeyList[0].keysValue;
					this.form.gapTime = timeOriginal.substring(0, timeOriginal.length - 1);
					this.form.timeUnit = timeOriginal.substring(timeOriginal.length - 1);
					
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.advanced-message {
		.footer {
			text-align: right;
			margin: 20px 0;
		}
	}
</style>